import React from 'react'
import {useSelector, useDispatch} from 'react-redux'
import IconButton from '@material-ui/core/IconButton'
import MoveToolIcon from '../../../common/Icons/MoveTool'
import SelectionToolIcon from '../../../common/Icons/SelectionTool'
import {setMode, selectionModeSelect} from '../../reducer/selectionMode'

import styles from '../DrawControl/DrawControl.module.scss'

export default function Instruments() {
    const dispatch = useDispatch()
    const isMobile = useSelector((state) => state.isMobile)
    const selectionMode = useSelector(selectionModeSelect)

    return (
        isMobile ? (
            <div className="panel-control panel-control_edit">
                <div className="panel-control__title">Инструменты</div>
                <div className="panel-control__content">
                    <div className="panel-control__item">
                        <IconButton
                            onClick={() => dispatch(setMode(false))}
                            className={!selectionMode ? styles.active : ''}
                        >
                            <MoveToolIcon />
                        </IconButton>
                    </div>
                    <div className="panel-control__item">
                        <IconButton
                            onClick={() => dispatch(setMode(true))}
                            className={selectionMode ? styles.active : ''}
                        >
                            <SelectionToolIcon />
                        </IconButton>
                    </div>
                </div>
            </div>
        ) : null
    )
}
